'use client'

import '@/views/personal/personal.css'

import { useEffect, useState } from 'react'

function ScrollAnimatedProgressBar({ children, data }) {
  const [activeItems, setActiveItems] = useState(Array.from({ length: data.length }, () => false))

  useEffect(() => {
    setActiveItems(Array.from({ length: data.length }, () => false))
  }, [data])

  useEffect(() => {
    const handleScroll = () => {
      const elements = document.querySelectorAll('.animated-list')
      const newActiveItems = [...activeItems]
      let hasChanged = false

      elements.forEach((element, index) => {
        const rect = element.getBoundingClientRect()
        const isVisible = rect.top <= window.innerHeight * 0.75
        if (newActiveItems[index] !== isVisible) {
          newActiveItems[index] = isVisible
          hasChanged = true
        }
      })

      if (hasChanged) {
        setActiveItems(newActiveItems)
      }
    }

    window.addEventListener('scroll', handleScroll)
    handleScroll()

    return () => window.removeEventListener('scroll', handleScroll)
  }, [])
  return (
    <div className="position-relative d-flex flex-1 flex-column gap-6 py-1 md:gap-10">
      <div className="progress-wrap-el position-absolute w-6 overflow-hidden">
        <div
          className="progress-line-el position-absolute left-0 top-0 z-0  w-100"
          style={{
            transform: `scaleY(${activeItems.filter(Boolean).length / activeItems.length})`,
            transformOrigin: 'top',
            transition: 'transform 0.5s ease',
            backgroundColor: '#221AFB'
          }}
        />
      </div>
      {children}
    </div>
  )
}

export default ScrollAnimatedProgressBar
